import { Icon } from '@oneaudi/unified-web-components';
import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

const StyledPoiIcon = styled(Icon)<{ color?: string }>`
  ${({ color }) => color && `color: ${color};`}
`;

export const PoiIcon: FC<{ color?: string; active?: boolean }> = ({ color, active }) => (
  <StyledPoiIcon name={active ? 'poi-active' : 'poi'} size="s" color={color} />
);
